import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
// import { AuthService } from '../../services/auth.service';
import * as fromApp from '../../store/app.reducer';
import * as AuthSelectors from '../../store/selectors/auth.selector';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import * as AuthActions from '../../store/actions/auth.actions';

@Injectable({ providedIn: 'root' })
export class AuthenticationGuard  {
  constructor(private router: Router, private store: Store<fromApp.AppState>, private oidcSecurityService: OidcSecurityService) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<true | UrlTree> {

    return this.store.select(AuthSelectors.selectActiveUser).pipe(
      take(1),
      map((activeUser) => {
        if (!!activeUser) {
          return true;
        }

        return this.router.createUrlTree(['/auth']);
      })
    );
  }
}
